module.exports = __webpack_public_path__ + "img/autospin_btn.7cad2b8e.png";